<template>
    <CompanyStatisticsComp></CompanyStatisticsComp>
  </template>
  <script>
  import CompanyStatisticsComp from "../components/CompanyStatisticsReport.vue";
  
  export default {
    name: "Company Statistics Report",
    components: { CompanyStatisticsComp },
    computed: {},
    mounted() {},
  };
  </script>
  